import { CONTENT } from "@/enums/enum-content";
import { ACCEPTOR_ERROR_CODE } from "../enums/enum-acceptor-error-code";
import messagesNotifyHelper from "./messages-notify-helper";

class TMNHelper {
    isTmnContent(content) {
        if (content) {
            if (content.id === CONTENT.PHYSICAL_MARKET ||
                content.id === CONTENT.FUTURE_MARKET ||
                content.id === CONTENT.INDICATIVE_MARKET ||
                content.id === CONTENT.EXCHANGE_MARKET ||
                content.id === CONTENT.ACTIVE_MARKET) {
                return true;
            }
        }
        return false
    }
    // Não foi possível carregar o sistema. Entre em contato com Suporte ao Cliente
    displayNotAuthorized(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => item.status == ACCEPTOR_ERROR_CODE.NOT_AUTHORIZED.code) >= 0;
        }
        return dataError.data.status == ACCEPTOR_ERROR_CODE.NOT_AUTHORIZED.code;
    }

    // Poe a mensagem: "Não foi possível carregar o sistema. Tente novamente mais tarde..." + botão de ATUALIZAR

    displayCannotLoadSystem(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => this.checkDisplayCannotLoadSystem(item.status)) >= 0;
        }
        return this.checkDisplayCannotLoadSystem(dataError.data.status);
    }
    checkDisplayCannotLoadSystem(code) {
        return code == ACCEPTOR_ERROR_CODE.STREAMER_UNAVAILABLE.code ||
            code == ACCEPTOR_ERROR_CODE.WEBAPP_UNAVAILABLE.code ||
            code == ACCEPTOR_ERROR_CODE.STREAMER_BUSY.code ||
            code == ACCEPTOR_ERROR_CODE.SERVICE_UNAVAILABLE.code ||
            code == ACCEPTOR_ERROR_CODE.SESSION_EXPIRED.code ||
            code == ACCEPTOR_ERROR_CODE.SESSION_NOT_FOUND.code;
    }

    // recarregar token no servidor
    refreshToken(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => this.checkRefreshToken(item.status)) >= 0;
        }
        return this.checkRefreshToken(dataError.data.status);
    }
    checkRefreshToken(code) {
        return code == ACCEPTOR_ERROR_CODE.INVALID_TOKEN.code ||
            code == ACCEPTOR_ERROR_CODE.INVALID_DOMAIN.code;
    }
    checkInvalidToken(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => item.status == ACCEPTOR_ERROR_CODE.INVALID_TOKEN.code) >= 0;
        }
        return dataError.data.status == ACCEPTOR_ERROR_CODE.INVALID_TOKEN.code;
    }
    checkExpiredToken(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => item.status == ACCEPTOR_ERROR_CODE.TOKEN_EXPIRED.code) >= 0;
        }
        return dataError.data.status == ACCEPTOR_ERROR_CODE.TOKEN_EXPIRED.code;
    }
    checkSessionNotFound(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => item.status == ACCEPTOR_ERROR_CODE.SESSION_NOT_FOUND.code) >= 0;
        }
        return dataError.data.status == ACCEPTOR_ERROR_CODE.SESSION_NOT_FOUND.code;
    }

    maxConnections(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => item.status == ACCEPTOR_ERROR_CODE.MAX_SIMULTANEOUS_CONNECTIONS.code) >= 0;
        }
        return dataError.data.status == ACCEPTOR_ERROR_CODE.MAX_SIMULTANEOUS_CONNECTIONS.code;
    }
    serviceUnavailable(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => item.status == ACCEPTOR_ERROR_CODE.SERVICE_UNAVAILABLE.code) >= 0;
        }
        return dataError.data.status == ACCEPTOR_ERROR_CODE.SERVICE_UNAVAILABLE.code;
    }
    invalidCredentials(dataError) {
        if (dataError.errors && dataError.errors.length > 0) {
            return dataError.errors.findIndex(item => item.status == ACCEPTOR_ERROR_CODE.INVALID_CREDENTIALS.code) >= 0;
        }
        return dataError.data.status == ACCEPTOR_ERROR_CODE.INVALID_CREDENTIALS.code;
    }

    checkNotifyErrors(dataError) {
        if (this.maxConnections(dataError)) {
            messagesNotifyHelper.errorNotify(
                this.$t('TOAST_NOTIFICATIONS').checkNotifyErrorTitle,
                this.$t('TOAST_NOTIFICATIONS').checkNotifyErrorTitleMessage
            );
            return;
        }
    }


}

export default new TMNHelper();
